import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { keyBy } from 'lodash'
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

import CircularProgress from '@mui/material/CircularProgress';

import {
  fetchEntity
} from 'cityads-v3/actions/entity';
import {
  getSadukaLanguages
} from 'cityads-v3/actions/language';
import {
  DEFAULT_LANGUAGE_ID
} from 'cityads-v3/i18n/utils';
import {
  OFFER_DESCRIPTION_TYPE_ID_FULL,
  OFFER_DESCRIPTION_TYPE_ID_PROMO,
} from 'cityads-v3/reducers/offers';

import classes from './Description.scss';

@connect(
  (state, props) => {
    const allDescriptions = state.entities.offerDescriptions?.data || [];
    const isLoadingDescriptions = state.entities.offerDescriptions?.isFetching;
    const descriptionsById = keyBy(allDescriptions, 'id');
    const currentLanguage = state.language.sadukaLanguagesByCode[state.language.language] || {};

    const descriptions = props.ids.map(id => descriptionsById[id]);

    return {
      descriptionsById,
      isLoadingDescriptions,
      fullDescription: (
        descriptions.find(({ language_id, type_id } = {}) => language_id === currentLanguage.id && type_id === OFFER_DESCRIPTION_TYPE_ID_FULL)
        || descriptions.find(({ language_id, type_id } = {}) => language_id === DEFAULT_LANGUAGE_ID && type_id === OFFER_DESCRIPTION_TYPE_ID_FULL)
      ),
      promoDescription: (
        descriptions.find(({ language_id, type_id } = {}) => language_id === currentLanguage.id && type_id === OFFER_DESCRIPTION_TYPE_ID_PROMO)
        || descriptions.find(({ language_id, type_id } = {}) => language_id === DEFAULT_LANGUAGE_ID && type_id === OFFER_DESCRIPTION_TYPE_ID_PROMO)
      ),
      languagesById: state.language.sadukaLanguagesById,
    }
  }
)
@withTranslation(['Offers'], { i18n, wait: false })
export default class Description extends Component {

  static propTypes = {
    ids: PropTypes.arrayOf(PropTypes.number).isRequired,

    descriptionsById: PropTypes.objectOf(PropTypes.object).isRequired,
    isLoadingDescriptions: PropTypes.bool,
    fullDescription: PropTypes.object,
    promoDescription: PropTypes.object,

    languagesById: PropTypes.object.isRequired,
  }

  componentDidMount() {
    this.reloadMissingLanguages();
    this.reloadMissingDescriptions();
  }

  reloadMissingLanguages() {
    const { languagesById, dispatch } = this.props;

    if (Object.keys(languagesById).length) { return; }

    dispatch(getSadukaLanguages());
  }

  reloadMissingDescriptions() {
    const { ids, descriptionsById, dispatch } = this.props;
    const reloadIds = ids.filter(id => !descriptionsById[id]);

    if (!reloadIds.length) { return; }

    dispatch(fetchEntity({ api: 'offerDescriptions', ids: ids }));
  }

  render() {
    const { t, fullDescription, promoDescription, languagesById, isLoadingDescriptions } = this.props;

    if (!Object.keys(languagesById).length || isLoadingDescriptions) {
      return (
        <div className={classNames(classes.container, classes.loading)}>
          <CircularProgress />
        </div>
      );
    }

    return (
      <div className={classes.container}>
        {promoDescription ? (
          <>
            <div className={classes.subtitle}>{t('page.promoDescription')}</div>
            <div className={classes.description} dangerouslySetInnerHTML={{ __html: promoDescription.text }} />
          </>
        ) : null}
        {fullDescription ? (
          <>
            <div className={classes.subtitle}>{t('page.fullDescription')}</div>
            <div className={classes.description} dangerouslySetInnerHTML={{ __html: fullDescription.text }} />
          </>
        ) : null}
      </div>
    );
  }
};
